import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import { ThreeDots } from 'platfi-ui-components';

import { bemModifier } from 'utils/BEMHelper';

import styles from './FullPageSpinner.scss';

const ONE_SECOND = 1000;
const TEN_SECONDS = 10 * ONE_SECOND;
const THIRTY_SECONDS = 30 * ONE_SECOND;

const MESSAGES = {
  firstTimeOut: 'This is taking a while...',
  secondTimeOut: "Looks like we're offline...",
};

const FullPageSpinner = ({ small, withNavbar }) => {
  const [loadingStatus, setLoadingStatus] = useState(null);
  const timeoutHandlers = useRef([]);

  useEffect(() => {
    timeoutHandlers.current.push(
      setTimeout(() => setLoadingStatus(MESSAGES.firstTimeOut), TEN_SECONDS),
    );
    timeoutHandlers.current.push(
      setTimeout(() => setLoadingStatus(MESSAGES.secondTimeOut), THIRTY_SECONDS),
    );
    return () => {
      timeoutHandlers.current.forEach(clearTimeout);
      timeoutHandlers.current = [];
    };
  }, []);

  const stylesName = classNames(
    ...bemModifier('m-full-page-spinner', {
      small,
      navbar: withNavbar,
    }),
  );

  return (
    <div styleName={stylesName} className="u-align-center">
      <div className="u-inline-block u-align-middle">
        <ThreeDots />
        <div styleName="m-full-page-spinner__message">{loadingStatus}</div>
      </div>
    </div>
  );
};

FullPageSpinner.propTypes = {
  small: PropTypes.bool,
  withNavbar: PropTypes.bool,
};

export default CSSModules(FullPageSpinner, styles, { allowMultiple: true });
